import { Icon, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const SuccessForm = () => {
  return (
    <div className={styles.wrap}>
      <div className={styles.iconWrap}>
        <Icon
          className={styles.icon}
          icon={'check1'}
          color={'var(--content-primary-primary-inverted)'}
        />
      </div>
      <Typography
        marginTop={24}
        variant={'heading-lg'}
        ariaLabel={'title'}
        color={'var(--content-primary-primary)'}
      >
        Email sent!
      </Typography>
      <Typography
        marginTop={8}
        variant={'body-lg-regular'}
        ariaLabel={'subtitle'}
        color={'var(--content-primary-tertiary)'}
      >
        Instructions to reset your password have been sent to your email.
      </Typography>
    </div>
  )
}

export default SuccessForm
